import { render, staticRenderFns } from "./CarManageDetail.vue?vue&type=template&id=b59bc0b4&scoped=true"
import script from "./CarManageDetail.vue?vue&type=script&lang=js"
export * from "./CarManageDetail.vue?vue&type=script&lang=js"
import style0 from "./CarManageDetail.vue?vue&type=style&index=0&id=b59bc0b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59bc0b4",
  null
  
)

export default component.exports